export default class IAuthStrategy {
  async login() {
    throw new Error("Метод login() должен быть реализован");
  }
}
